import { Component, Input, OnInit } from '@angular/core';

import { Rating } from './rating/rating';
import { TraditionalRatingService } from './rating/traditional-rating.service';

@Component({
  selector: 'app-sustainability-rating',
  templateUrl: './sustainability-rating.component.html',
  styleUrls: ['./sustainability-rating.component.css']
})
export class SustainabilityRatingComponent implements OnInit {

  @Input() onShowPeriod;
  @Input() showGoals;
  @Input() showTrends;
  @Input() showBusinessAreas;
  @Input() onFlexGrid;
  @Input() onEdit;
  
  mockRatings: Rating [];
  ratings: Rating [];

  constructor(
    private _traditionalRatingService: TraditionalRatingService
  ) {}

  getMockRatings(): void {
    this._traditionalRatingService.getMockRatings().then(mockRatings => this.mockRatings = mockRatings);
  }

  getRatings(): void {
    this._traditionalRatingService.getRatings().then(ratings => this.ratings = ratings);
  }

  ngOnInit(): void {
    this.getMockRatings();
    this.getRatings();
  }

}



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/canvas/components/sustainability-rating/sustainability-rating.component.ts